import React from "react";
import { Button, Modal } from "react-bootstrap";

export const DeleteConfirmDialog = ({formName, message, showDeleteConfirmPop, setShowDeleteConfirmPop, handleDelete }) => {


    const handleClose = () => {
        setShowDeleteConfirmPop(false)
    }
    const handleDeleteInfo = () => {
        handleDelete()
    }

  return (
    <React.Fragment>
      <Modal show={showDeleteConfirmPop} centered>
        <Modal.Header className="dialog-header" closeButton onClick={handleClose}>
          <Modal.Title >{`Delete ${formName}`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p>{message}</p>
        </Modal.Body>
        <Modal.Footer>
            <Button className="orange-button" onClick={() => handleDeleteInfo()} >Delete</Button>
            <Button variant="secondary" onClick={handleClose} >Cancel</Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};
